





















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import type { ModeloDeEtiquetaServiceAdapter } from '@/usecases'
import {
	EstacaoDeImpressao,
	HistoricoDeEmissaoDeEtiqueta,
	JobDeImpressaoNoHistorico,
	situacoesDoJobDeImpressao,
	StatusDaFatiaDeImpressao,
} from '@/models/EstacaoDeImpressao'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

export const HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY = 'HISTORICO_DE_EMISSAO_DE_ETIQUETA'
const MAX_HISTORICO_LOCAL = 10

@Component
export default class DialogoDeHistoricoDeEtiqueta extends Vue {
	@Inject('ModeloDeEtiquetaServiceAdapter')
	private modeloDeEtiquetaService!: ModeloDeEtiquetaServiceAdapter

	readonly LIMITE = 20
	readonly INTERVALO_DE_ATUALIZACAO_MS = 5000

	aberto = false
	aba = 0

	carregandoEnviadas = false
	reimprimindoIdEnviado: string | null = null
	historicoEnviado: JobDeImpressaoNoHistorico[] = []
	lojaId = ''
	estacoes: EstacaoDeImpressao[] = []
	private timerDeAtualizacao: number | null = null

	historicoLocal: HistoricoDeEmissaoDeEtiqueta[] = []
	reimprimindoIdLocal: string | null = null

	mostrar(lojaId: string, estacoes: EstacaoDeImpressao[]) {
		this.lojaId = lojaId
		this.estacoes = estacoes
		this.historicoEnviado = []
		this.aba = lojaId ? 0 : 1
		this.aberto = true
		this.carregarHistoricoLocal()
		if (lojaId) this.carregarEnviadas()
	}

	setCarregando(id: string | null) {
		this.reimprimindoIdLocal = id
	}

	static salvar(item: HistoricoDeEmissaoDeEtiqueta) {
		try {
			const historico: HistoricoDeEmissaoDeEtiqueta[] = JSON.parse(
				localStorage.getItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY) || '[]',
			)
			historico.unshift(item)
			if (historico.length > MAX_HISTORICO_LOCAL) {
				historico.length = MAX_HISTORICO_LOCAL
			}
			localStorage.setItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY, JSON.stringify(historico))
		} catch { /* silently fail */ }
	}

	async carregarEnviadas() {
		if (!this.lojaId) return
		try {
			this.carregandoEnviadas = true
			this.historicoEnviado = await this.modeloDeEtiquetaService.buscarHistoricoDeImpressao(this.lojaId, this.LIMITE)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoEnviadas = false
			this.agendarAtualizacaoSeHouverLoteEmAndamento()
		}
	}

	@Watch('aberto')
	aoAbrirOuFechar(aberto: boolean) {
		if (!aberto) {
			this.pararAtualizacao()
		}
	}

	beforeDestroy() {
		this.pararAtualizacao()
	}

	private agendarAtualizacaoSeHouverLoteEmAndamento() {
		this.pararAtualizacao()
		if (!this.aberto || !this.temLoteEmAndamento()) return
		this.timerDeAtualizacao = window.setTimeout(
			() => this.atualizarEmSilencio(), this.INTERVALO_DE_ATUALIZACAO_MS)
	}

	private async atualizarEmSilencio() {
		if (!this.aberto || !this.lojaId) return
		try {
			this.historicoEnviado = await this.modeloDeEtiquetaService.buscarHistoricoDeImpressao(this.lojaId, this.LIMITE)
		} catch (error: any) {
			// Falha aqui não vira alerta: a atualização é de fundo e repetiria o aviso a cada 5s.
		}
		this.agendarAtualizacaoSeHouverLoteEmAndamento()
	}

	private pararAtualizacao() {
		if (this.timerDeAtualizacao === null) return
		window.clearTimeout(this.timerDeAtualizacao)
		this.timerDeAtualizacao = null
	}

	private temLoteEmAndamento(): boolean {
		return this.historicoEnviado.some(job => job.status === 'ENFILEIRANDO'
			|| job.fatias.some(fatia => fatia.status === 'ENFILEIRADA'))
	}

	async reimprimirEnviado(job: JobDeImpressaoNoHistorico) {
		try {
			this.reimprimindoIdEnviado = job.id
			const resultado = await this.modeloDeEtiquetaService.reimprimirJob(job.id)
			AlertModule.setSuccess(
				`Reenviado para impressão: ${resultado.quantidadeDeEtiquetas} etiqueta(s) em ${resultado.totalDeFatias} parte(s).`,
			)
			await this.carregarEnviadas()
			this.$emit('reimprimiu', resultado)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.reimprimindoIdEnviado = null
		}
	}

	nomeDaEstacao(estacaoId: string): string {
		return this.estacoes.find(estacao => estacao.id === estacaoId)?.nome || 'Impressora removida'
	}

	situacao(job: JobDeImpressaoNoHistorico) {
		return situacoesDoJobDeImpressao[job.status] || { rotulo: job.status, cor: 'grey' }
	}

	progresso(job: JobDeImpressaoNoHistorico): string {
		if (job.status === 'CONCLUIDO') {
			return `${job.quantidadeDeEtiquetas} etiqueta(s)`
		}
		if (job.quantidadeConfirmada === 0) {
			return `${job.quantidadeDeEtiquetas} etiqueta(s) · nenhuma confirmada ainda`
		}
		const faltando = job.quantidadeDeEtiquetas - job.quantidadeConfirmada
		return `imprimiu ${job.quantidadeConfirmada} de ${job.quantidadeDeEtiquetas}`
			+ (faltando > 0 ? ` · ${faltando} não saíram` : '')
	}

	mostraDetalhe(job: JobDeImpressaoNoHistorico): boolean {
		return job.status === 'PARCIAL' || job.status === 'FALHOU'
	}

	corDaFatia(status: StatusDaFatiaDeImpressao): string {
		if (status === 'IMPRESSA' || status === 'ENTREGUE_AO_SPOOL') return 'success'
		if (status === 'FALHOU' || status === 'DESCARTADA') return 'error'
		return 'grey'
	}

	carregarHistoricoLocal() {
		try {
			this.historicoLocal = JSON.parse(localStorage.getItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY) || '[]')
		} catch {
			this.historicoLocal = []
		}
	}

	reimprimirLocal(item: HistoricoDeEmissaoDeEtiqueta) {
		this.reimprimindoIdLocal = item.id
		this.$emit('reimprimir', item)
	}

	limparHistoricoLocal() {
		localStorage.removeItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY)
		this.historicoLocal = []
	}

	totalDeEtiquetas(item: HistoricoDeEmissaoDeEtiqueta): number {
		return item.itens.reduce((total, produto) => total + (Number(produto.quantidade) || 0), 0)
	}

	formatarDataHora(iso: string): string {
		return new Date(iso).toLocaleString('pt-BR')
	}
}
